import {GoalV3} from '@/features/chat/chat.model'
import {GoalStatusesE, GoalType} from '@/features/goal/types'
import {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import GoalCountdown from '../../goal-countdown/GoalCountdown'
import {StyledCanceled, StyledCountdown} from './style'

type HostStatusSectionProps = {
    goal: Partial<GoalV3> | Partial<GoalType>
}

export const GuestDetailsStatusSection = ({goal}: HostStatusSectionProps) => {
    const {t} = useTranslation()
    const endDate = (goal as GoalV3)?.endDate ?? (goal as GoalType)?.end_date

    const content = useMemo(() => {
        switch (goal?.status) {
            case GoalStatusesE.ACTIVE:
                return <StyledCountdown>{endDate && <GoalCountdown endDate={endDate} />}</StyledCountdown>
            case GoalStatusesE.REVIEW:
            case GoalStatusesE.SUSPENDED:
                return <StyledCanceled>{t('goal_page:goal_details:status_suspended')}</StyledCanceled>
            case GoalStatusesE.CANCELED:
                return <StyledCanceled>{t('goal_page:goal_details:status_canceled')}</StyledCanceled>
            default:
                return null
        }
    }, [goal?.status])

    return <>{content}</>
}

// !!!IMPORTANT - this rules only for GUEST side!!!

// 1. If status "active" - show countdown
// 2. If status "suspended", "review" - show red text "Goal suspended"
// 3. If status "canceled" - show red text "Canceled"
// 3. If status "awaiting_proof", "proof_pending_approval", "successful" - don't show anything
